import { TableHead, TableRow, TableCell, TableBody, Table, useMediaQuery, Theme } from '@mui/material';
import { MoreVertical } from 'react-feather';

import { formatDateToString } from '../../../utils/date';
import { BikeBoxReservation } from '../../../utils/types';
import TableCellMenu from '../TableCellMenu/TableCellMenu';
import { capitalizeText } from '../../../utils/format';

type Props = {
    reservations: BikeBoxReservation[];
    handleDeleteReservation: (reservationId: number) => void;
};

const BikeBoxReservationsTable = ({ reservations, handleDeleteReservation }: Props) => {
    const sortedReservations = [...reservations].sort((a, b) => {
        return new Date(a.fromDate).getTime() - new Date(b.fromDate).getTime();
    });

    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Navn</TableCell>
                    <TableCell>{isMobile ? 'Mobilnr.' : 'Mobilnummer'}</TableCell>
                    <TableCell>{isMobile ? 'Fra' : 'Fra-dato'}</TableCell>
                    <TableCell>{isMobile ? 'Til' : 'Til-dato'}</TableCell>
                    <TableCell></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {sortedReservations.map(reservation => {
                    return (
                        <TableRow key={reservation.authorizationId}>
                            <TableCell>{reservation.authorizationId}</TableCell>
                            <TableCell>{capitalizeText(reservation.customerName)}</TableCell>
                            <TableCell>{reservation.phoneNumber}</TableCell>
                            <TableCell>
                                {isMobile ? formatDateToString(new Date(reservation.fromDate), 'dd/MM/yyyy', true) : formatDateToString(new Date(reservation.fromDate), 'EEEE do MMMM yyyy', true)}
                            </TableCell>
                            <TableCell>
                                {isMobile ? formatDateToString(new Date(reservation.toDate), 'dd/MM/yyyy', true) : formatDateToString(new Date(reservation.toDate), 'EEEE do MMMM yyyy', true)}
                            </TableCell>
                            <TableCell align='right'>
                                <TableCellMenu
                                    icon={<MoreVertical color='#000' size={20} />}
                                    rowMenuItems={[
                                        {
                                            name: 'Slett reservasjon',
                                            clickHandler: () => handleDeleteReservation(reservation.authorizationId),
                                        },
                                    ]}
                                />
                            </TableCell>
                        </TableRow>
                    );
                })}
            </TableBody>
        </Table>
    );
};

export default BikeBoxReservationsTable;
